import { Grid } from '@mui/material';
import React from 'react'
import SelectInputBox from '../../../../../../constants/SelectInputBox';
import { VoucherContextType } from '../../../../../../context/VoucherEntryContext';
import InputTextBox from '../../../../../../constants/InputTextBox';
import { useSelector } from 'react-redux';
import { RootState } from '../../../../../../store/store';
import { ParticularOptions, SubLedgerOptions } from '../../../../../../constants/Options';
import { BsPencil } from 'react-icons/bs';
interface HeaderFormViewProps {
    context: VoucherContextType;
}

const CardFormView: React.FC<HeaderFormViewProps> = ({ context }) => {
    const { values, setFieldValue, handleChange, handleBlur, touched, errors } = context;
    const handleSelectBox = (name: string, selectedOption: any) => {
        const value = selectedOption ? selectedOption.value : null;
        setFieldValue(name, value);
    };
    const { AccountSubledgerList, AccountBankParticularList } = useSelector((state: RootState) => state.accounts);
    const subLedgerOptions = AccountSubledgerList ? SubLedgerOptions(AccountSubledgerList) : [];
    const bankParticularOptions = ParticularOptions(AccountBankParticularList);
    return (
        <Grid container columnSpacing={1} rowSpacing={0.5}>
            <Grid item lg={6} md={6} xs={12} xl={6} sm={12}>
                <SelectInputBox
                    label='Card Bank Type'
                    options={subLedgerOptions}
                    optionSelect={(name, selectedOption) => {
                        handleSelectBox(name, selectedOption);
                    }}
                    isLoading={false}
                    value={values.bank_sglsn}
                    required={true}
                    placeholder='Select Card bank'
                    name='bank_sglsn'
                    handleBlur={handleBlur}
                    touched={touched.bank_sglsn}
                    errors={errors.bank_sglsn}
                />
            </Grid>
            <Grid item lg={6} md={6} xs={12} xl={6} sm={12}>
                <InputTextBox
                    type='text'
                    label='Card Number'
                    name='chequeno'
                    handleChange={handleChange}
                    handleBlur={handleBlur}
                    disabled={false}
                    value={values.chequeno}
                    error={errors.chequeno}
                    placeholder='Enter chequeno'
                    required={false}
                />
            </Grid>
            <Grid item lg={6} md={6} xs={12} xl={6} sm={12}>
                <InputTextBox
                    type='text'
                    label='Card name'
                    name='bearername'
                    handleChange={handleChange}
                    handleBlur={handleBlur}
                    disabled={false}
                    value={values.bearername}
                    error={errors.bearername}
                    placeholder='Enter bearername'
                    required={false}
                />
            </Grid>
            <Grid item lg={6} md={6} xs={12} xl={6} sm={12}>
                <SelectInputBox
                    label='Card Deposite/Return'
                    options={bankParticularOptions}
                    optionSelect={(name, selectedOption) => {
                        handleSelectBox(name, selectedOption);
                    }}
                    isLoading={false}
                    value={values.dep_particular_id}
                    required={true}
                    placeholder='Select Cash particular'
                    name='dep_particular_id'
                    handleBlur={handleBlur}
                    touched={touched.dep_particular_id}
                    errors={errors.dep_particular_id}
                />
            </Grid>
            <Grid item lg={12} md={12} xs={12} xl={12} sm={12}>
                <InputTextBox
                    type='text'
                    prefix={<BsPencil />}
                    label='Remarks'
                    name='billingcomment'
                    handleChange={handleChange}
                    handleBlur={handleBlur}
                    value={values.billingcomment}
                    placeholder='Enter Remarks'
                    error={errors.billingcomment}
                    required={false}
                />
            </Grid>

        </Grid>
    )
}

export default CardFormView